import React, { Component } from 'react';
import Switch from 'react-switch';

class ToggleSwitch extends Component {
  constructor() {
    super();
    this.state = { checked: false };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(checked) {
    this.setState({ checked });
  }

  render() {
    //const { checked } = this.state;
    return (
      <Switch
        offColor="#FF7002"
        onChange={this.props.handleChange}
        checked={this.props.switched}
      />
    );
  }
}

export default ToggleSwitch;